import { SEO } from '../../utils/seo';

export default function VisionPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '私たちの目指す世界 - Our Vision',
    description: 'ブロックチェーンとAIで実現する「デジタル情報を信頼できる社会」と「暮らしのDX」。改ざん耐性の高いデータ基盤と対話型AIで、医療・決済・生活サービスの信頼性向上と業務効率化を推進します。',
    url: `${siteUrl}/vision`,
    mainEntity: {
      '@type': 'Article',
      headline: 'Vision – 「デジタル情報を信頼できる社会」と「暮らしのDX」',
      description: '急速なデジタル化の一方で、情報改ざんやセキュリティリスクは年々高まっています。私たちは、ブロックチェーンにより改ざん耐性の高いデータ基盤を構築し、医療・決済・生活サービスなど、暮らしに直結する領域で「信頼できるデジタル社会」を実現します。',
      author: {
        '@type': 'Organization',
        name: '株式会社ガイアライブラリー'
      }
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Our Vision - 私たちの目指す世界｜株式会社ガイアライブラリー"
        description="ブロックチェーンとAIで実現する「デジタル情報を信頼できる社会」と「暮らしのDX」。改ざん耐性の高いデータ基盤と対話型AIで、医療・決済・生活サービスの信頼性向上と業務効率化を推進します。"
        keywords="ビジョン,ブロックチェーン,AI,デジタル社会,健康DX,信頼性,セキュリティ"
        schema={schema}
      />
      {/* Page Header with Background */}
      <div className="relative bg-gradient-to-br from-blue-900 to-blue-700 text-white py-32 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://public.readdy.ai/ai/img_res/e190d14436e21eb53a0fb47b038ebb7b.jpg"
            alt="Vision Background"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <p className="text-sm tracking-widest uppercase mb-4 text-blue-200">Our Vision</p>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">私たちの目指す世界</h1>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 py-24 md:py-32">
        {/* Page Label */}
        <p className="text-sm tracking-widest uppercase text-blue-600 text-center mb-4">
          Our Vision
        </p>

        {/* Main Heading */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-blue-900 text-center mb-12 leading-tight">
          Vision – 「デジタル情報を信頼できる社会」と「暮らしのDX」
        </h1>

        {/* Decorative Line */}
        <div className="w-32 h-px bg-blue-200 mx-auto mb-12"></div>

        {/* Content */}
        <div className="text-base md:text-lg leading-loose text-gray-700 space-y-8">
          <p>
            急速なデジタル化の一方で、情報改ざんやセキュリティリスクは年々高まっています。<br />
            私たちは、ブロックチェーンにより改ざん耐性の高いデータ基盤を構築し、<br />
            医療・決済・生活サービスなど、暮らしに直結する領域で「信頼できるデジタル社会」を実現します。
          </p>

          <p>
            同時に、AIを活用した対話型アプリやエージェント技術によって、
          </p>

          <ul className="pl-6 space-y-3">
            <li className="flex items-start">
              <span className="text-blue-600 mr-3">・</span>
              <span>健康管理の負担軽減</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-3">・</span>
              <span>行政・医療現場の業務効率化</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-3">・</span>
              <span>高齢者を含む全世代が使いやすいサービス</span>
            </li>
          </ul>

          <p>
            を実現し、「人がより人らしく活躍できる社会づくり」に貢献していきます。
          </p>
        </div>
      </div>
    </div>
  );
}
